import { makeStyles } from '@material-ui/core'
import { Theme } from '@styles/theme/theme'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    '& button': {
      padding: '24px 12px'
    }
  },
  videoWrapper: {
    alignItems: 'center',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    overflow: 'hidden',
    width: '100%',

    '& video': {
      width: '100%',
    },

    [theme.breakpoints.down('sm')]: {
      height: '286px',
    },

  },
}))

export default useStyles
